import { AuthProvider, useAuth } from "@/context/AuthContext";
import { NavigationProvider, useNavigation } from "@/context/NavigationContext";
import { SessionProvider } from "@/context/SessionContext";
import { BootScreen } from "@/screens/BootScreen";
import { CelebrationScreen } from "@/screens/CelebrationScreen";
import { FirstPassScreen } from "@/screens/FirstPassScreen";
import { FlashCardScreen } from "@/screens/FlashCardScreen";
import { AlphabetScreen } from "@/screens/AlphabetScreen";
import { HomeScreen } from "@/screens/HomeScreen";
import { LoginScreen } from "@/screens/LoginScreen";
import { MyStickersScreen } from "@/screens/MyStickersScreen";
import { ParentArea } from "@/screens/ParentArea";
import { PastWeeksScreen } from "@/screens/PastWeeksScreen";
import { PhaseIntroScreen } from "@/screens/PhaseIntroScreen";
import { ResultsScreen } from "@/screens/ResultsScreen";
import { SecondChanceScreen } from "@/screens/SecondChanceScreen";
import { ThreeXWriteScreen } from "@/screens/ThreeXWriteScreen";

export function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}

function AuthGate() {
  const { status } = useAuth();
  if (status === "pending") return <BootScreen />;
  if (status === "unauthenticated") return <LoginScreen />;
  return (
    <NavigationProvider>
      <SessionProvider>
        <AppRouter />
      </SessionProvider>
    </NavigationProvider>
  );
}

function AppRouter() {
  const { screen } = useNavigation();
  switch (screen) {
    case "home":
      return <HomeScreen />;
    case "parent":
      return <ParentArea />;
    case "flashCard":
      return <FlashCardScreen />;
    case "phaseIntro:firstPass":
      return <PhaseIntroScreen kind="firstPass" />;
    case "firstPass":
      return <FirstPassScreen />;
    case "results":
      return <ResultsScreen />;
    case "phaseIntro:secondChance":
      return <PhaseIntroScreen kind="secondChance" />;
    case "secondChance":
      return <SecondChanceScreen />;
    case "phaseIntro:threeXWrite":
      return <PhaseIntroScreen kind="threeXWrite" />;
    case "threeXWrite":
      return <ThreeXWriteScreen />;
    case "celebration":
      return <CelebrationScreen />;
    case "myStickers":
      return <MyStickersScreen />;
    case "alphabet":
      return <AlphabetScreen />;
    case "pastWeeks":
      return <PastWeeksScreen />;
  }
}
